module.exports = __webpack_public_path__ + "media/images/icons/arrow_down-335e82c35e581fe24fe668e243849536.svg";